import firebase from 'firebase/app';
import { saveSearch } from '../SaveSearch/SaveSearch';

export const addProspect = async(fbProfile, profile, LIurl, interests, auth, foundInts, setShowSpinner, setDocId) =>{

    const msg = '';

    var newDoc = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc()
 
    await newDoc
    .set({
        CreatedBy: fbProfile.email,
        Company: fbProfile.company,
        Linkedin: LIurl,
        ProspectName: profile.full_name,
        ProspectCompany: (profile.experiences.length > 0) ? profile.experiences[0].company : '',
        ProspectRole: profile.occupation ? profile.occupation : '',
        ProspectActivities: (profile?.activities?.length > 0) ? profile.activities : '',
        ProspectArticles: (profile?.articles?.length > 0) ? profile.articles : '',
        ProspectInterest: interests,
        ProspectContent: '',
        contactImg: profile.profile_pic_url,
        contactEducation: profile?.education[0]?.school ? profile?.education[0]?.school : '',
        contactFieldOfStudy: profile?.education[0]?.field_of_study ? profile?.education[0]?.field_of_study : '',
        contactHeadline: profile.headline,
        contactCity: profile.city ? profile.city : '',
        contactSummary: profile?.summary ? profile.summary : '',
        contactExp: profile?.experiences[0] ? profile.experiences[0] : '',
        createdAt: new Date(),
        AuthorID: auth.uid,
        AuthorFirstName: fbProfile.firstName,
        AuthorLastName: fbProfile.lastName,
        MessageApproved: 'No',
        MessageSent: 'No',
        InterestPreAi: foundInts,
        CreatedfromApp: "Yes",
        CreatedfromCext: "No",
    }).then(
        setDocId(newDoc.id),
        setShowSpinner(false),
        saveSearch(fbProfile, auth, profile, LIurl, interests, msg, foundInts, newDoc.id)
    )
}